import React from 'react'

function SideBar() {
  return (<div class="sidebar off-canvas-sidebar" data-background-color="white" data-active-color="danger">
    <div class="sidebar-wrapper">
      <div class="logo">
        <a class="simple-text">
          <img src="assets/img/aesmc-logo.png" style={{ 'width' : '200px'  }}/>
        </a>
      </div>
      <ul class="nav">
        <li >
          <a href="/dashboard">
            <i class="ti-dashboard"></i>
            <p>Dashboard</p>
          </a>
        </li>
        <li>
          <a href="/search">
            <i class="ti-search"></i>
            <p>Search</p>
          </a>
        </li>
      </ul>
    </div>
  </div>)

}
export default SideBar